"use client";

import { SurveyQuestionResponse } from "@yardzen/api-dtos";
import { IconName } from "@yardzen/ui/components/icon";
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import AddressResponse from "./AddressResponse";
import DynamicMultipleTextFieldsResponse from "./DynamicMultipleTextFieldsResponse";
import MultipleChoiceResponse from "./MultipleChoiceResponse";
import MultipleTextFieldsResponse from "./MultipleTextFieldsResponse";
import SingleChoiceResponse from "./SingleChoiceResponse";
import { TextResponse } from "./TextResponse";
export function QuizResponse({
  responseType,
  options,
  maxLength,
  placeholder = "",
  fields,
  surveyQuestionResponse,
  register,
  setValue,
  getValues,
}: {
  responseType: string;
  options?: { value: string; text: string; icon: IconName }[];
  maxLength?: number;
  placeholder?: string;
  fields?: { key: string; label: string; maxLength?: number }[];
  surveyQuestionResponse?: SurveyQuestionResponse;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
}) {
  switch (responseType) {
    case "single-choice":
      return (
        <SingleChoiceResponse
          options={options || []}
          surveyQuestionResponse={surveyQuestionResponse}
          setValue={setValue}
          register={register}
        />
      );
    case "multiple-choice":
      return (
        <MultipleChoiceResponse
          options={options || []}
          surveyQuestionResponse={surveyQuestionResponse}
          fields={fields}
          register={register}
          setValue={setValue}
          getValues={getValues}
        />
      );
    case "text":
      return (
        <TextResponse
          maxLength={maxLength ?? 500}
          placeholder={placeholder}
          surveyQuestionResponse={surveyQuestionResponse}
          register={register}
        />
      );
    case "address":
      return (
        <AddressResponse
          placeholder={placeholder}
          surveyQuestionResponse={surveyQuestionResponse}
          register={register}
        />
      );
    case "multiple-text-fields":
      return (
        <MultipleTextFieldsResponse
          fields={fields || []}
          surveyQuestionResponse={surveyQuestionResponse}
          register={register}
        />
      );
    case "dynamic-multiple-text-fields":
      return (
        <DynamicMultipleTextFieldsResponse
          fields={fields || []}
          surveyQuestionResponse={surveyQuestionResponse}
          register={register}
        />
      );
    default:
      return <div>Unsupported response type: {responseType}</div>;
  }
}
